(function () {
  'use strict';

  // Mobile menu (opened from the header or the floating bar)
  var toggles = document.querySelectorAll('[data-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  if (toggles.length && menu) {
    var closeBtn = menu.querySelector('[data-menu-close]');
    var opener = null;
    var open = function (e) { opener = e.currentTarget; menu.hidden = false; opener.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; if (closeBtn) closeBtn.focus(); };
    var close = function () { menu.hidden = true; document.body.style.overflow = ''; if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); } };
    toggles.forEach(function (t) { t.addEventListener('click', open); });
    if (closeBtn) closeBtn.addEventListener('click', close);
    menu.addEventListener('click', function (e) { if (e.target === menu) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) close(); });
  }

  // Floating menu bar: appears once the full header has scrolled away
  var pill = document.querySelector('[data-hpill]');
  var fullHeader = document.querySelector('[data-header]');
  if (pill && fullHeader) {
    var shown = false, pending = false;
    var check = function () {
      pending = false;
      var show = fullHeader.getBoundingClientRect().bottom < -20;
      if (show === shown) return;
      shown = show;
      pill.classList.toggle('is-visible', show);
      if (show) pill.removeAttribute('inert'); else pill.setAttribute('inert', '');
    };
    window.addEventListener('scroll', function () { if (!pending) { pending = true; window.requestAnimationFrame(check); } }, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  // Auto-submit selects and cart quantities
  document.querySelectorAll('[data-auto-submit]').forEach(function (el) {
    el.addEventListener('change', function () { if (el.form) el.form.submit(); });
  });

  // Confirm before deleting an address
  document.querySelectorAll('[data-confirm]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { if (!window.confirm('Delete this address?')) e.preventDefault(); });
  });

  // Login page: show the password recovery form
  var recover = document.querySelector('[data-toggle-recover]');
  if (recover) recover.addEventListener('click', function () { var box = document.getElementById('Recover'); if (box) box.scrollIntoView({ behavior: 'smooth' }); });

  // Product: quantity buttons and variant picker
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var form = root.querySelector('[data-product-form]');
    if (!form) return;
    var qty = form.querySelector('input[name="quantity"]');
    form.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.qty, 10));
        qty.value = n;
      });
    });

    var json = root.querySelector('[data-product-json]');
    if (!json) return;
    var data = JSON.parse(json.textContent);
    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add-button]');
    var priceEl = root.querySelector('[data-price-current]');
    var compareEl = root.querySelector('[data-price-compare]');
    var radios = form.querySelectorAll('input[data-option-index]');

    function selected() {
      var opts = [];
      radios.forEach(function (r) { if (r.checked) opts[parseInt(r.dataset.optionIndex, 10)] = r.value; });
      return opts;
    }
    function update() {
      var opts = selected();
      var v = data.variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      opts.forEach(function (o, i) { var l = root.querySelector('[data-option-label="' + i + '"]'); if (l) l.textContent = o; });
      if (!v) {
        addBtn.disabled = true; addBtn.textContent = data.labels.unavailable; return;
      }
      idInput.value = v.id;
      priceEl.textContent = v.price;
      if (v.compare) { compareEl.textContent = v.compare; compareEl.hidden = false; } else { compareEl.hidden = true; }
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? data.labels.add : data.labels.soldOut;
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString());
      if (v.media) { var m = root.querySelector('[data-media-id="' + v.media + '"]'); if (m && m.parentNode.firstElementChild !== m) m.parentNode.prepend(m); }
    }
    radios.forEach(function (r) { r.addEventListener('change', update); });
  });
})();
